// extracted by mini-css-extract-plugin
export var badgeLeft = "LevelUp-module--badge-left--eba75";
export var badgeRight = "LevelUp-module--badge-right--c0f77";
export var badges = "LevelUp-module--badges--2a46b";
export var container = "LevelUp-module--container--6c0b2";
export var fadeAndTranslate1Left = "LevelUp-module--fadeAndTranslate1Left--454b5";
export var fadeAndTranslate1Right = "LevelUp-module--fadeAndTranslate1Right--90758";
export var fadeAndTranslate2Left = "LevelUp-module--fadeAndTranslate2Left--dec57";
export var fadeAndTranslate2Right = "LevelUp-module--fadeAndTranslate2Right--3d261";
export var fadeAndTranslate3Left = "LevelUp-module--fadeAndTranslate3Left--d0fba";
export var fadeAndTranslate3Right = "LevelUp-module--fadeAndTranslate3Right--403a8";
export var fadeAndTranslate4Left = "LevelUp-module--fadeAndTranslate4Left--f5c03";
export var fadeAndTranslate4Right = "LevelUp-module--fadeAndTranslate4Right--95a83";
export var firstToGo = "LevelUp-module--first-to-go--42246";
export var languageLogo = "LevelUp-module--language-logo--db605";
export var languageLogoContainer = "LevelUp-module--language-logo-container--13d63";
export var logoFirst = "LevelUp-module--logo-first--44ee3";
export var logoSecond = "LevelUp-module--logo-second--6d1af";
export var logoThird = "LevelUp-module--logo-third--21dc7";
export var secondToGo = "LevelUp-module--second-to-go--b33c4";
export var shiftBehindLeft = "LevelUp-module--shift-behind-left--876f6";
export var shiftBehindRight = "LevelUp-module--shift-behind-right--9872e";
export var thirdToGo = "LevelUp-module--third-to-go--13cdb";
export var wrapper = "LevelUp-module--wrapper--29997";